<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                      {{ $tc('message.prestation',2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <b-container>
                        <b-row>
                            <b-col col sm="12">
                                <section class="container" id="appointment-table">
                                    <div class="appointment-table-header my-2 mb-4">
<!--                                       <b-button @click="handleOnAddClick" v-if="can">-->
<!--                                            <i class="fa fa-plus edit-icon"></i>-->
<!--                                            {{ $t('message.add') }}-->
<!--                                        </b-button>-->

                                        <div class="d-inline-block ml-1 mr-5 width-270">
                                            <b-input-group
                                                    size="sm"
                                                    class="mb-3"
                                            >
                                                <b-form-input
                                                        type="text"
                                                        size="sm"
                                                        class="p-2 h-100"
                                                        :placeholder="$t('message.filter') + '...'"
                                                        v-model="filterCriteria"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-button
                                                            size="sm"
                                                            text="Button"
                                                            variant="primary"
                                                            @click="handlerOnFilterButton"
                                                    >
                                                        Go
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>

                                            <div
                                                v-if="paginationObject.numOfPages > 1"
                                                class="pagination-wrapper d-inline-block"
                                            >
                                                <div class="pagination">
                                                    <a
                                                        href="#"
                                                        :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                            @click="_handlePaginationClick('prev')"
                                                    >
                                                        <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                    </a>
                                                    <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                        <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                        </template>
                                                        <template v-else>
                                                            <a
                                                                    href="#"
                                                                    :key="key"
                                                                    class="page-numbers"
                                                                    @click="_handlePaginationClick(pageNumber)"
                                                            >
                                                                {{ pageNumber }}
                                                            </a>
                                                        </template>
                                                    </template>
                                                    <a
                                                            href="#"
                                                            class="next page-numbers"
                                                            :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                            @click="_handlePaginationClick('next')"
                                                    >
                                                        <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row appointment-table-content">
                                        <div class="container-fluid">
                                            <template
                                                v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0"
                                            >
                                                <div
                                                    v-for="(_institution, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                    :key="key"
                                                    class="row appointment-item hovered"
                                                    @click="onEtablissementClick(_institution.slug)"
                                                >
                                                    <div class="col-lg-4">
                                                        <span class="appointment-label">
                                                            {{ $t('message.nomEtablissement') }}
                                                        </span>
                                                        <h4 class="appointment-date">{{ _institution.name }}</h4>
                                                    </div>
                                                    <div class="col-lg-8">
                                                        <span class="appointment-label">
                                                            {{ $t('message.description') }}
                                                        </span>
                                                        <h4
                                                            class="appointment-hour"
                                                        >
                                                            {{ _institution.description }}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                            </template>

                                        </div>
                                    </div>
                                </section>

                                <!--<vue-good-table
                                        id="operation"
                                        :columns="etablissementColumns"
                                        :rows="etablissementRows"
                                        :search-options="{
                                        enabled:true,
                                        }"
                                        :pagination-options="paginationOptions"
                                        @on-row-click="onEtablissementClick"
                                />-->
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
	import { pagination, handlePaginationClick } from "../../helpers/paginations";
	import { displayNumber } from "../../helpers/general";

    export default {
        name: "List",

        computed: {
            ...mapGetters(['hasAdminRole',"userInstitutions",
                'hasGestionnaireRole','hasMedecinControleRole','isComptable','hasAssistante']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante || this.hasAssistante;
            },

            etablissementColumns: function () {
                return [
                    {
                        label: this.$i18n.t('message.nomEtablissement'),
                        field: 'nom',
                    },
                    {
                        label: this.$i18n.t('message.nomPrestation'),
                        field: 'nomPrestation',
                    },
                    {
                        label: this.$i18n.t('message.price'),
                        field: 'prix',
                    },
                    {
                        label: this.$i18n.t('message.reduction'),
                        field: 'reduction',
                    }
                ];
            },

            etablissementRows: function() {
                let iArray = [];
                // let self = this;
                _.forEach(this.userInstitutions, function(institution) {
                    let i = {};
                    _.forEach(institution.prestations, function (prestation) {
                        i.nom = institution.name;
                        i.slug = prestation.slug;
                        i.nomPrestation = prestation.prestation.nom;
                        i.prix = prestation.prix;
                        i.reduction = prestation.reduction;
                        iArray.push(i);
                    })

                });
                return _.uniqBy(iArray, item => item.name);
            },
        },

        data(){
            return {
				filterCriteria: '',
				institutions: [],
				paginationObject: {},
                slug: '',
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
            }
        },

        watch: {
			userInstitutions: function (newValue, oldValue) {
				this.institutions = newValue
					.filter(institution => institution.prestations && institution.prestations.length > 0)
					.map(institution => ({
						slug: institution.slug,
						name: institution.name,
						description: institution.description
					}));
			},

			institutions: function (newValue, oldValue) {
				this.paginationObject = pagination(newValue);
			},

			filterCriteria: function (newValue, oldValue) {
				this.handleFilter(newValue);
			}
        },

        methods:{
			handleOnAddClick() {
				this.$router.push({ name: 'add-etablissement-prestations' });
            },

			handlerOnFilterButton() {
				event.preventDefault();
				this.handleFilter(this.filterCriteria);
			},

			_handlePaginationClick(action) {
				this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
			},

			handleFilter(value) {
				if (value) {
					const newInstitutions = this.institutions.filter(app => {
						let result = false;

						if (app.name) {
							result = result || app.name.toLowerCase().includes(value.toLowerCase());
						}

						if (app.description) {
							result = result || app.description.toLowerCase().includes(value.toLowerCase());
						}

						return result;
					});

					this.paginationObject = pagination(newInstitutions);
				} else {
					this.paginationObject = pagination(this.institutions);
				}
			},

            onEtablissementClick(slug){
                this.$router.push({ name: 'etablissement-prestations-list', params: { prestation_etablissement: slug } });
            },

            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

			_displayNumber: displayNumber,
        },

        mounted() {
            this.getUserInstitutions();
        }
    }
</script>

<style scoped>

</style>
